export default __webpack_public_path__ + "static/media/MeatGrading.df8fb128.jpg";